import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const KEY_LOGO_URL = '/elemantra-key-logo.png';

export const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="relative py-16 bg-[#2A2624] border-t border-[#3D3935] overflow-hidden"
      data-testid="footer"
    >
      {/* Watermark Key Logo */}
      <div 
        className="absolute inset-0 flex items-center justify-center pointer-events-none"
        style={{ opacity: 0.03 }}
      >
        <img 
          src={KEY_LOGO_URL} 
          alt="" 
          className="w-[60%] max-w-2xl h-auto object-contain invert"
          aria-hidden="true"
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="flex flex-col items-center gap-6">
          {/* Logo */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="flex flex-col items-center"
          >
            <img 
              src={KEY_LOGO_URL} 
              alt="Elemantra" 
              className="w-32 md:w-40 h-auto object-contain invert opacity-80 mb-1"
              data-testid="footer-logo"
            />
            <span className="font-cormorant text-xl md:text-2xl tracking-[0.2em] text-[#FDFBF7] uppercase">
              Elemantra
            </span>
            <p className="font-outfit text-xs tracking-widest text-[#9A948C] mt-2 uppercase">
              {t.footer.tagline}
            </p>
          </motion.div>

          {/* Divider */}
          <div className="w-12 h-px bg-[#B89C6A]/30 mt-2" />

          {/* Copyright */}
          <div className="text-center">
            <p className="font-outfit text-xs tracking-wide text-[#6B665F]">
              © {currentYear} Elemantra. {t.footer.rights}
            </p>
            <p className="font-outfit text-[10px] tracking-wide text-[#5C5650] mt-3">
              EU Responsible: Solutioneering AS
            </p>
            <p className="font-outfit text-[10px] tracking-wide text-[#5C5650] mt-1">
              Grinibraten 11E, Voyenenga, 1339, Oslo, Norway
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
